import React, { createContext, useContext, useState } from "react";
import { useAuth } from "./AuthContext.hook";
import { IAuthContext } from "./AuthContext.types";

const AuthContext = createContext<IAuthContext | null>(null);

export const AuthProvider = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  const contextValue = useAuth();

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const [isVerified, setIsVerified] = useState(localStorage.getItem("bt") !== null);

  return {
    isVerified,
    setIsVerified,
    ...(useContext(AuthContext) as IAuthContext),
  };
};
